export const isDebug = process.env.NODE_ENV !== 'production';

export const debugLog: typeof console.log = (...args: any[]) => {
  if (isDebug) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
